import React from "react";
import personMp4 from "../assets/videos/person.mp4";
import personWebm from "../assets/videos/person.webm";
import pdf from "../assets/pdfs/resume.pdf";

const About = () => {
  return (
    <section className="about-container" id="about">
      <h1 className="heading-1">About</h1>
      <div className="about">
        <video className="about__video" autoPlay loop muted>
          <source src={personMp4} type="video/mp4"></source>
          <source src={personWebm} type="video/webm"></source>
          Sorry, your browser doesn't support embedded videos.
        </video>
        <p className="about__text">
          Hey there, I am <span>Amit Singh</span>, a Mumbai based self-taught{" "}
          <span>Full-Stack Web Developer</span>. I am a person who has a keen interest in{" "}
          <span>solving real-world problems</span> that have a massive impact
          and <span>uplift society with my problem-solving approach</span>.
        </p>
        <div className="about__group">
          <span className="about__span">INTERESTED &#63;</span>
          <a
            href={pdf}
            title="Amit's Resume'"
            download="Amit's Resume'.pdf"
            className="resume"
          >
            My Resume'
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
